import React, { useContext } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import TruckViewPage from "./TruckViewPage";
import { UserDataContext } from "../Contexts/UserDataContext";
import DefaultRoute from "./DefaultRoute";
import { PropTypes } from "prop-types";

const WeekRoute = (props) => {
  const { userData } = useContext(UserDataContext);
  const { truckId } = props;
  const weeks = [0, 1, 2, 3, 4];

  return (
    <Switch>
      {weeks.map((week) => (
        <Route
          key={week}
          path={`/${userData.userName}/trucks/${truckId}/weeks/${week}`}
          component={() => <TruckViewPage truckId={truckId} week={week} />}
          exact
        />
      ))}
      <DefaultRoute />
    </Switch>
  );
};

export default WeekRoute;

WeekRoute.propTypes = {
  truckId: PropTypes.number.isRequired,
};
